import summarizeStyle from "./summarize.module.css";
import React, { useState } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import InteractionsByHour from "../../components/tables/InteractionsByHour";
import ActionBtn from "../../components/UI/actionbtn";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../services/api";
import { toast } from "react-toastify";
import CircularLoading from "../../components/loadModules/circularLoading.js";

export default function SmsList() {
  const defaultWabaSearch = {
    data_start: "",
  };

  const [wabaSearch, setWabaSearch] = useState({ ...defaultWabaSearch });
  const [retornoAPI, setRetornoAPI] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (type, value) => {
    let _wabaSearch = { ...wabaSearch };
    _wabaSearch[type] = value;
    setWabaSearch({ ..._wabaSearch });
  };

  const loadTables = async () => {
    if (wabaSearch.data_start === "") {
      toast.warning("Preencha o campo de data para a busca");
      return;
    }

    const selectedDate = new Date(wabaSearch.data_start);

    if (isNaN(selectedDate.getTime())) {
      toast.warning("Data inválida. Verifique o campo de data.");
      return;
    }

    // Normaliza para meia-noite pra comparar só a data
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      toast.warning("A data não pode ser futura.");
      return;
    }

    const diffMs = today.getTime() - selectedDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays > 31) {
      toast.warning(
        "O intervalo máximo permitido é de 31 dias a partir de hoje."
      );
      return;
    }

    setLoading(true);

    try {
      const res = await api.get(
        `/api/database/report/interacoes_hora?date_start=${wabaSearch.data_start}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.data || res.data.length === 0) {
        toast.error("Erro #004: Sem resultado de busca");
        setRetornoAPI([]);
        return;
      }

      setRetornoAPI(res.data);
      toast.success("Dados carregados com sucesso");
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      toast.error("Erro ao carregar dados");
      setRetornoAPI([]);
    } finally {
      setLoading(false);
    }
  };

  const cleanSearch = () => {
    setWabaSearch({ ...defaultWabaSearch });
    setRetornoAPI([]);
  };

  return (
    <div className={summarizeStyle.summarize}>
      <div className="d-flex align-items-center justify-content-between pe-4">
        <p className="titlePage">Interações por hora</p>
        <div className="d-flex align-items-center">
          <div
            className={`d-flex align-items-center me-5 ${summarizeStyle.containerTimerHeader}`}
          >
            <label className="defaultLabel me-2">Data: </label>
            <input
              className="input-bootstrap"
              type="date"
              id="searchdateto"
              value={wabaSearch.data_start}
              onChange={(e) => handleChange("data_start", e.target.value)}
            />
          </div>

          {/* Limpar busca */}
          <div
            onClick={() => {
              if (!loading) cleanSearch();
            }}
            style={{
              pointerEvents: loading ? "none" : "auto",
            }}
          >
            <ActionBtn
              color="yellow"
              icon={<SearchOffIcon />}
              disabled={loading}
            />
          </div>

          {/* Buscar */}
          <div
            onClick={() => {
              if (!loading) loadTables();
            }}
            style={{
              pointerEvents: loading ? "none" : "auto",
            }}
          >
            <ActionBtn color="green" icon={<SearchIcon />} disabled={loading} />
          </div>
        </div>
      </div>

      <div className={summarizeStyle.sumBottomBox}>
        {loading ? (
          <CircularLoading />
        ) : (
          <StyledEngineProvider injectFirst>
            <InteractionsByHour data={retornoAPI} />
          </StyledEngineProvider>
        )}
      </div>
    </div>
  );
}
